import classnames from 'classnames';
import type { FunctionComponent, ReactNode } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';

import styles from './Label.module.scss';

interface Props {
  label: string | JSX.Element;
  count?: number;
  disabled?: boolean;
  active?: boolean;
  icon?: ReactNode;
  className?: string;
}

export const Label: FunctionComponent<Props> = ({
  label,
  count,
  disabled = false,
  active = false,
  icon,
  className,
}) => {
  const labelClassName = classnames(styles.root, className, {
    [styles.disabled]: disabled,
    [styles.active]: active,
  });

  const labelCount = (
    <Text tag="span" type="small" className={styles.count}>
      {`(${count})`}
    </Text>
  );

  return (
    <div key="label" className={labelClassName}>
      <Text className={styles.label}>
        {label}
        {count && labelCount}
      </Text>

      {icon && icon}
    </div>
  );
};

Label.displayName = 'Label';
